// Drag-and-drop component — handles drag ghost, drop zones, and data transfer
// Usage:
//   DragDrop.initDraggable({ container, itemSelector, idAttr, multiSelect })
//   DragDrop.onDrop(element, callback)  — callback receives { taskIds, event, target }

var DragDrop = {
  // Create a drag ghost showing task count. When ghostText (a function of count)
  // is provided, render its plain text with a neutral border instead of the
  // default task-themed markup — lets non-task consumers label their own drags.
  _createGhost: function (count, ghostText) {
    var existing = document.getElementById('drag-ghost');
    if (existing) existing.parentNode.removeChild(existing);

    var ghost = document.createElement('div');
    ghost.id = 'drag-ghost';
    ghost.style.cssText = 'position:absolute;top:-1000px;left:-1000px;z-index:99999;pointer-events:none;min-width:48px;min-height:38px;background:#fff;box-shadow:0 2px 10px rgba(44,44,89,.13);border-radius:8px;border:2px solid #3c92e8;display:flex;align-items:center;justify-content:center;padding:0 16px;font-size:1em;font-weight:500;';

    if (typeof ghostText === 'function') {
      ghost.style.border = '1px solid #999';
      ghost.style.borderRadius = '2px';
      ghost.textContent = ghostText(count);
    } else if (count === 1) {
      ghost.innerHTML = '<i class="fas fa-tasks" style="font-size:1.4em;margin-right:8px;color:#228be6;"></i>1 Task';
    } else {
      ghost.innerHTML =
        '<i class="fas fa-tasks" style="font-size:1.4em;margin-right:8px;color:#228be6;"></i>' +
        '<i class="fas fa-tasks" style="font-size:1em;position:relative;left:-10px;top:-8px;opacity:.44;color:#228be6;"></i>' +
        '<span style="margin-left:2px;">' + count + ' Tasks</span>';
    }
    document.body.appendChild(ghost);
    return ghost;
  },

  _removeGhost: function () {
    var ghost = document.getElementById('drag-ghost');
    if (ghost) ghost.parentNode.removeChild(ghost);
  },

  // Initialize draggable items — wires up dragstart/dragend on all matching items
  // multiSelect: a MultiSelect instance (optional) for multi-drag support
  // ghostText: optional function(count) -> string for a custom drag-ghost label
  initDraggable: function (opts) {
    var containerSel = opts.container || '.tasks-list';
    var itemSel = opts.itemSelector || '[data-id]';
    var idAttr = opts.idAttr || 'data-id';
    var multiSelect = opts.multiSelect || null;
    var ghostText = typeof opts.ghostText === 'function' ? opts.ghostText : null;

    function attach() {
      document.querySelectorAll(containerSel).forEach(function (container) {
        container.querySelectorAll(itemSel).forEach(function (el) {
          el.setAttribute('draggable', 'true');

          el.ondragstart = function (event) {
            var id = el.getAttribute(idAttr);
            var selected;

            if (multiSelect && multiSelect.selectedIds.size > 0 && multiSelect.selectedIds.has(id)) {
              selected = multiSelect.getSelected();
            } else {
              selected = [id];
              if (multiSelect) {
                multiSelect.selectedIds = new Set([id]);
                multiSelect.syncUi();
              }
            }

            event.dataTransfer.setData('text/plain', JSON.stringify(selected));
            event.dataTransfer.effectAllowed = 'move';

            var ghost = DragDrop._createGhost(selected.length, ghostText);
            try { event.dataTransfer.setDragImage(ghost, 24, 16); } catch (e) {}
          };

          el.ondragend = function () {
            DragDrop._removeGhost();
          };
        });
      });
    }

    // Attach now and expose for re-attachment after DOM changes
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }

    return { reattach: attach };
  },

  // Parse dropped task IDs from a drop event
  getDropData: function (event) {
    var raw = event.dataTransfer.getData('text/plain');
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : (parsed ? [parsed] : []);
    } catch (e) {
      return [];
    }
  },

  // Convenience: add drop zone behavior to an element
  // hoverClass: CSS class to add during dragover
  // onDrop: function(taskIds, event) called on drop
  makeDropZone: function (element, opts) {
    var hoverClass = opts.hoverClass || 'drop-hover';

    element.addEventListener('dragover', function (e) {
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
      element.classList.add(hoverClass);
    });

    element.addEventListener('dragleave', function () {
      element.classList.remove(hoverClass);
    });

    element.addEventListener('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove(hoverClass);
      var ids = DragDrop.getDropData(e);
      if (ids.length && typeof opts.onDrop === 'function') {
        opts.onDrop(ids, e);
      }
    });
  }
};

window.DragDrop = DragDrop;
